<template>
    <div class="body back-gray">
        <div class="wrap end txt-center">
            <p class="bold font-20">
                평가가 완료되었습니다.
            </p>
            <p class="font-16 mt-20">
                평가서는 등록 시 입력하신 이메일<br>
                <span class="txt-gray">({{email}})</span>로<br>
                발송되었습니다.
            </p>
        </div>
        <div class="wrap">
            <div class="btn-fixed">
                <button class="btn-full" @click="goIntro()">확인</button>
            </div>
        </div>
        <!-- 푸터 -->
        <Footer></Footer>
    </div>
</template>
<script>
    import Footer from '@/components/footer.vue';
    export default {
        name: 'IntroEv',
        components: {
            Footer
        },
        data: () => ({
            email:""
        }),
        mounted() {
            this.email = atob(this.$route.params.email);
        },
        methods: {
            goIntro(){
                location.href='/intro'
            }

        }
    }
</script>